import RestProvider from "providers/RestProvider";
import { cruds, datosLogin, properties } from "./PageAccesoConContrasenaData";
import { useHistory } from "react-router-dom";
import { useState, useContext } from "react";
import CryptoJS from "crypto-js";
import AuthProvider from "providers/authProvider";
import AppContext from "AppContext";
import { useDispatch, useSelector } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';

const useFunctions = () => {
  const { crudOperation, crudOperationsType } = RestProvider();
  const history = useHistory();
  const [message, setMessage] = useState({ msg: "", severity: "" });
  let _ID = 0;
  const addAlert = (msg) => setAlerts([...alerts, { id: _ID++, msg }]);
  const [alerts, setAlerts] = useState([]);
  const handleSetMessage = (msg, severity) => {
    setMessage({ msg, severity });
    addAlert(message);
  };
  const [isLoading, setIsLoading] = useState(false);
  const { login } = AuthProvider();
  const contexto = useContext(AppContext);
  const urlProcedenciaProcedimiento = useSelector((state) => state.kingdomOV3.urlProcedenciaProcedimiento);

  const dispatch = useDispatch();
  const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);

/**
 * @function handleOnSubmit Función que se ejecutará cuando se produzca en el formulario el evento onSubmit
 */
const handleOnSubmit = async (data) => {
  setIsLoading(true);
  let loginResponse = {};

  try {
    // Paso 1. Se construye el objeto requerido para realizar el logado con usuario y contraseña
    let obj = await buildObjLoginRequest(data);

    // Paso 2. Obtenemos la respuesta al logado y el id del interesado en caso positivo
    const loginResponse = await crudOperation(crudOperationsType.CUSTOM, cruds.loginRequest.resource, {
      url: cruds.loginRequest.url,
      method: "post",
      data: obj,
    });

    let interesadoLogado = loginResponse.data.idInteresado.toString();

    // Paso 3. logamos la aplicación con el usuario "ciudadano" para obtener los permisos necesarios a la siguiente consulta
    await login("ciudadano", "", false);

    // Paso 4. Obtenemos los datos del interesado
    const userResponse = await crudOperation(crudOperationsType.CUSTOM, cruds.interesado.resource, {
      url: interesadoLogado,
      method: "get",
    });

    // Paso 5. Formateamos los datos recibidos y los almacenamos en el estado global (infoUsuario)
    const infoUsuarioObtenido = {
      interesadoNif: userResponse.data.identificador,
      interesadoNombre: userResponse.data.nombre,
      interesadoApellido1: userResponse.data.apellido1,
      interesadoApellido2: userResponse.data.apellido2 || '',
      tipoAutenticacion: properties.TIPO_AUTENTICACION_REGISTRADO,
      entidadCif: null, 
      entidadNombre: null
    };
    dispatch(insertNewState({filnedName: 'infoUsuario', value: infoUsuarioObtenido}));

    // Paso 6. Informamos a la aplicación que se ha realizado un inicio de sesión
    contexto.updateSesion("inicioSesion");

    // Paso 7. Registramos contra MOAD el nuevo inicio de sesión
    setTimeout(registrarLogado, 500);

    // Paso 8 (y final). Saltamos a la bandeja de solicitudes.
    history.push("/BandejaSolicitudes");
    
  } catch (error) {
    setIsLoading(false);
    if (error.response && error.response.status === 400) {
      handleSetMessage("Ha ocurrido un error al validar el usuario", "error");
    } else if (error.response && error.response.status === 401) {
      handleSetMessage("Cuenta bloqueada. Intentelo de nuevo pasados 30 minutos", "error");
    } else if (error.response && error.response.status === 404) {
      handleSetMessage("Usuario o Contraseña incorrecto", "error");
    } else {
      // En caso de otros errores, manejar según sea necesario
      console.error("Error desconocido:", error);
    }
  }

  return loginResponse;
};

  /**
   * @constant buildObjLoginRequest Creamos el objeto para solicitar el logado
   * @param {*} data
   * @returns
   */
  const buildObjLoginRequest = async (data) => {
    datosLogin.usuario = data.data.usuario;
    datosLogin.contrasena = hashPassword(data.data.contrasena);
    return { ...datosLogin };
  };

  /**
   * @function handleCustomEvents Función que captura los eventos de los botones customizados
   * @param {*} customEvent
   */
  const handleCustomEvents = (customEvent) => {
    // Captura cuando se hace click sobre el botón Atrás
    if (customEvent.type === "btnAtras") {
      history.push('/SeleccionConvocatoriaPerfil' + urlProcedenciaProcedimiento);
    }
    if (customEvent.type === "btnRegister") {
      history.push("/AltaUsuarioConContrasena");
    }
  };

  /**
   * @function hashPassword Función que obtiene el hash256 de la contraseña suministrada por el usuario
   * @param {*} password
   * @returns
   */
  const hashPassword = (password) => {
    const hash = CryptoJS.SHA256(password);
    const hexHash = hash.toString(CryptoJS.enc.Hex);
    return hexHash;
  };

  /**
   * @function crearObjetoCredencial Función que prepara las credenciales que se enviarán a MOAD para el
   * registro de la sesión
   * @param {*} password
   * @returns
   */
  const crearObjetoCredencial = () => {
    let credencialDto = {
      tipoAutenticacion: 'cl',
      nifUsuario: infoUsuario.interesadoNif,
      nombre: infoUsuario.interesadoNombre,
      apellido1: infoUsuario.interesadoApellido1,
      apellido2: infoUsuario.interesadoApellido2,
      tipoCredencial: properties.TIPO_CRE_FACHADA
    };
    return credencialDto;
  };

  /**
   * @function registrarLogado Realiza el registro en MOAD del inicio de sesión
   * @param {*} password
   * @returns
   */
  const registrarLogado = () => {
    crudOperation(crudOperationsType.CUSTOM, cruds.validacion.resource, {
      url: cruds.validacion.url,
      method: "post",
      data: crearObjetoCredencial(),
    });
  };

  return {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage
  };
};

export default useFunctions;
